import React from 'react';
import ContentLoader from 'react-content-loader';
import { Box } from '@mafc/trolly';

import CartListLayout from './CartListLayout';

const displayPropXS = ['block', '', 'none'];
const displayPropLG = ['none', '', 'block'];

const CartListLoader = () => (
  <CartListLayout>
    <Box display={displayPropXS} mx={[3, 4]} py={3}>
      <ContentLoader
        className="skeleton-loader"
        height={120}
        width={490}
        speed={2}
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
      >
        <rect x="0" y="28" rx="2" ry="2" width="24" height="24" />
        <rect x="46" y="0" rx="0" ry="0" width="80" height="80" />

        <rect x="150" y="0" rx="5" ry="5" width="200" height="11" />
        <rect x="150" y="30" rx="5" ry="5" width="150" height="10" />

        <rect x="150" y="60" rx="5" ry="5" width="120" height="10" />
        <circle cx="165" cy="105" r="15" />
        <rect x="192" y="100" rx="5" ry="5" width="100" height="10" />
        <circle cx="319" cy="105" r="15" />
      </ContentLoader>
    </Box>
    <Box display={displayPropLG} mx={[3, 4]} py={3}>
      <ContentLoader
        className="skeleton-loader"
        height={98}
        width={800}
        speed={2}
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
      >
        <rect x="0" y="28" rx="2" ry="2" width="24" height="24" />
        <rect x="46" y="0" rx="0" ry="0" width="80" height="80" />

        <rect x="150" y="0" rx="5" ry="5" width="200" height="11" />
        <rect x="150" y="30" rx="5" ry="5" width="150" height="10" />

        <rect x="680" y="0" rx="5" ry="5" width="120" height="11" />
        <rect x="680" y="30" rx="5" ry="5" width="120" height="10" />

        <rect x="150" y="78" rx="5" ry="5" width="120" height="10" />
        <circle cx="631" cy="80" r="15" />
        <rect x="658" y="75" rx="5" ry="5" width="100" height="10" />
        <circle cx="785" cy="80" r="15" />
      </ContentLoader>
    </Box>
  </CartListLayout>
);

export default CartListLoader;
